import type {
    INotification,
    INotificationEvent,
} from '../../types/notifications'
import { baseApi } from '../baseApi'
import type { ResponseType } from '../types'

const notificationManagerBase = 'api/dispatchers/notification-manager'
const notificationBase = 'api/notifications'

export const notificationApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllNotificationEvents: builder.query<
            ResponseType<INotificationEvent[]>,
            string
        >({
            query: (query) => `${notificationManagerBase}/events/?${query}`,
        }),
        getAllNotification: builder.query<
            ResponseType<INotification[]>,
            string
        >({
            query: (query) => `${notificationManagerBase}/?${query}`,
        }),

        getNotificationById: builder.query<ResponseType<INotification>, number>(
            {
                query: (id) => `${notificationManagerBase}/${id}`,
            },
        ),

        createNotificationEvent: builder.mutation<
            ResponseType<INotificationEvent>,
            { name: string }
        >({
            query: ({ name }) => ({
                url: `${notificationManagerBase}/events/`,
                method: 'POST',
                body: { name },
            }),
        }),
        updateNotificationEvent: builder.mutation<
            ResponseType<INotificationEvent>,
            { id: number; name: string }
        >({
            query: ({ id, name }) => ({
                url: `${notificationManagerBase}/events/${id}`,
                method: 'PUT',
                body: { name },
            }),
        }),
        deleteNotificationEvent: builder.mutation<
            ResponseType<{ id: number }>,
            number
        >({
            query: (id) => ({
                url: `${notificationManagerBase}/events/${id}`,
                method: 'DELETE',
            }),
        }),

        createNotification: builder.mutation<
            ResponseType<INotification>,
            Partial<INotification>
        >({
            query: (body) => ({
                url: `${notificationManagerBase}`,
                method: 'POST',
                body,
            }),
        }),
        updateNotification: builder.mutation<
            ResponseType<INotification>,
            { id: number; body: Partial<INotification> }
        >({
            query: ({ id, body }) => ({
                url: `${notificationManagerBase}/${id}`,
                method: 'PUT',
                body,
            }),
        }),
        deleteNotification: builder.mutation<
            ResponseType<{ id: number }>,
            number
        >({
            query: (id) => ({
                url: `${notificationManagerBase}/${id}`,
                method: 'DELETE',
            }),
            transformResponse: (response: ResponseType<any>, meta, id) => ({
                ...response,
                data: { ...response, id },
            }),
        }),

        getMyNotification: builder.query<ResponseType<INotification[]>, string>(
            {
                query: (query) => `${notificationBase}?${query}`,
            },
        ),
        markByIdMyNotification: builder.mutation<
            ResponseType<INotification[]>,
            number
        >({
            query: (id) => ({
                url: `${notificationBase}/${id}`,
                method: 'PATCH',
            }),
        }),
        markAllMyNotification: builder.mutation({
            query: () => ({
                url: `${notificationBase}`,
                method: 'PATCH',
            }),
        }),
    }),
})

export const {
    useGetAllNotificationEventsQuery,
    useGetAllNotificationQuery,
    useGetNotificationByIdQuery,
    useCreateNotificationEventMutation,
    useUpdateNotificationEventMutation,
    useDeleteNotificationEventMutation,
    useCreateNotificationMutation,
    useUpdateNotificationMutation,
    useDeleteNotificationMutation,
    useGetMyNotificationQuery,
    useMarkByIdMyNotificationMutation,
    useMarkAllMyNotificationMutation,
} = notificationApi
